<p *ngIf="successfulSubmission == false">
    To apply for the Asthma Educator Specialty Examination read and complete the information below. 
    If you do not intend to attempt the Asthma Educator Specialty Examination do not submit this information.
</p>
<div *ngIf="!successfulSubmission && !disciplineAudit">
    <p>
        To qualify for the Asthma Educator Specialty Examination, you must meet one of the following requirements:
    </p>
    <ol>
        <li>
            Be issued a current, active, unrestricted license or credential from the United States in one of the following:
            <ul>
                <li>Physicians (MD, DO)</li>
                <li>Physician Assistants (PA-C)</li>
                <li>Nurses (RN, LPN, NP)</li>
                <li>Respiratory Therapists (RRT, CRT)</li>
                <li>
                    Pulmonary Function Technologists (CPFT, RPFT)
                </li>
                <li>Pharmacists (RPh)</li>
                <li>Social Workers (CSW)</li>
                <li>Speech Language Pathologist (CCC-SLP)</li>
                <li>Health Educators (CHES)</li>
                <li>Physical Therapist (PT)</li>
                <li>Occupational Therapist (OT)</li>
                <li>
                    Emergency Medical Technician (EMT, AEMT)
                </li>
                <li>Paramedic</li>
            </ul>
        </li>
        <li>
            Have a minimum of 1,000 hours of direct patient asthma education, counseling or coordinating services prior to applying for the examination. 
        If applying under this admission route, you must submit a
            <a href="https://nbrc.org/ae-c-application">paper application</a>
            form and payment to the NBRC office for processing. If you do not have an active US license or credential, you must apply 
        under this eligibility route.
        </li>
    </ol>
</div>
<div *ngIf="successfulSubmission && disciplineAudit">
    <div>
        <p>
            Your profile was successfully created. Your record has been selected for audit. To complete the application process, 
            you must submit proof of your selected license or credential. You may do this by selecting “Continue” below, 
            logging into the Practitioner Portal at
            <a href="/auth">nbrc.org</a>
            , or emailing a PDF copy to
            <a href="mailto:apply@nbrc.org.">apply@nbrc.org</a>
            .
        </p>
        <p>
            When your audit is complete you will receive an email with instructions to complete the application process or with further instructions. 
            You may login to the
            <a href="/auth">Practitioner Portal</a>
            to check the status of your audit; however, you should allow two weeks for processing 
            once your documentation has been received.
        </p>
        <p>
            Please contact our office at
            <a href="mailto:apply@nbrc.org.">apply@nbrc.org</a>
            or 913.895.4900 if you have any questions.
        </p>

    </div>
    <div class="form-row">
        <input
            class="button form-actions__item"
            type="submit"
            value="Continue"
            (click)="continue()"
        >
    </div>
</div>
<div *ngIf="successfulSubmission && !disciplineAudit">
    <div>
        <p>
            Your profile was successfully created. You can now login and apply for the examination.  You may do this by selecting “Continue” below, 
            logging into the Practitioner Portal at
            <a href="/auth">nbrc.org</a>
            .
        </p>
        <p>
            Please contact our office at
            <a href="mailto:apply@nbrc.org.">apply@nbrc.org</a>
            or 913.895.4900 if you have any questions.
        </p>
    </div>
    <div class="form-row">
        <input
            class="button form-actions__item"
            type="submit"
            value="Continue"
            (click)="continue()"
        >
    </div>
</div>
<form
    [formGroup]="studentForm"
    class="form new-student-form"
    (ngSubmit)="onSubmit(studentForm.value)"
    *ngIf="successfulSubmission == false && alreadyComplete == false"
>
    <fieldset class="form-section">
        <p>
            I am a currently licensed or credentialed U.S. health care professional active and unrestricted in the following profession. 
            I understand that audits of first time candidates is a routine part of NBRC’s commitment of ensuring public safety and complying 
            with standard regulatory practices. If selected for audit, I will be notified on screen and by email and will have a period of 
            two weeks to submit the required documentation.
        </p>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="discipline"
                    class="label"
                >
                    License or Credential
                </label>
                <select
                    class="input input--select-menu input--xlarge"
                    [class.input--invalid]="formErrors.discipline"
                    id="discipline"
                    formControlName="discipline"
                >
                    <option value>Select One</option>
                    <option
                        *ngFor="let c of disciplineLov"
                        [value]="c.codeValue"
                    >
                        {{c.codeDescription}}
                    </option>
                    <option value="S">Student</option>
                </select>
                <div
                    *ngIf="formErrors.discipline"
                    class="error-message field__error-message"
                >
                    {{ formErrors.discipline }}
                </div>
            </div>
        </div>
    </fieldset>
    <div *ngIf="disciplinePicked==4||disciplinePicked==5">
        Login to your Practitioner Portal account at
        <a href="/auth">nbrc.org</a>
        to apply for the examination.
    </div>
    <div *ngIf="disciplinePicked==30">
        If you are applying for the examination with 1,000 hours of direct patient asthma education, counseling or coordinating services you must 
        submit a
        <a href="https://nbrc.org/ae-c-application">paper application</a>
        form and payment. If you do not have an active US license or credential, 
        you must apply under this eligibility route.
    </div>
    <div *ngIf="disciplinePicked=='S'">
        You do not qualify for the examination until you are currently licensed or an active and unrestricted credentialed health care professional.
    </div>

    <fieldset
        *ngIf="validDiscipline"
        class="form-section"
    >
        <legend>Personal Information</legend>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="ssn"
                    class="label"
                >
                    SSN
                </label>
                <input
                    class="input"
                    id="ssn"
                    [class.input--invalid]="formErrors.ssn"
                    formControlName="ssn"
                    mask="000-00-0000"
                    placeholder="XXX-XX-XXXX"
                    [dropSpecialCharacters]="true"
                >
                <div
                    *ngIf="formErrors.ssn"
                    class="error-message field__error-message"
                >
                    {{ formErrors.ssn }}
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="firstName"
                        class="label"
                    >
                        First Name
                    </label>
                    <input
                        class="input"
                        id="firstName"
                        [class.input--invalid]="formErrors.firstName"
                        formControlName="firstName"
                        uppercase
                        maxlength="30"
                    >
                    <div
                        *ngIf="formErrors.firstName"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.firstName }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="middleName"
                        class="label"
                    >
                        Middle Name
                        <span class="label__help-text">(optional)</span>
                    </label>
                    <input
                        class="input"
                        id="middleName"
                        [class.input--invalid]="formErrors.middleName"
                        formControlName="middleName"
                        uppercase
                        maxlength="30"
                    >
                    <div
                        *ngIf="formErrors.middleName"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.middleName }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="lastName"
                        class="label"
                    >
                        Last Name
                    </label>
                    <input
                        class="input"
                        [class.input--invalid]="formErrors.lastName"
                        id="lastName"
                        formControlName="lastName"
                        uppercase
                        maxlength="30"
                    >
                    <div
                        *ngIf="formErrors.lastName"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.lastName }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="suffix"
                        class="label"
                    >
                        Suffix
                        <span class="label__help-text">(optional)</span>
                    </label>
                    <select
                        class="input input--select-menu"
                        id="suffix"
                        formControlName="suffix"
                    >
                        <option value>Select One</option>
                        <option value="JR">JR</option>
                        <option value="SR">SR</option>
                        <option value="I">I</option>
                        <option value="II">II</option>
                        <option value="III">III</option>
                        <option value="IV">IV</option>
                        <option value="V">V</option>
                        <option value="VI">VI</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="gender"
                        class="label"
                    >
                        Gender
                    </label>
                    <select
                        class="input input--select-menu"
                        [class.input--invalid]="formErrors.gender"
                        id="gender"
                        formControlName="gender"
                    >
                        <option value>Select One</option>
                        <option
                            *ngFor="let c of genderLov"
                            [value]="c.codeValue"
                        >
                            {{c.codeDescription}}
                        </option>
                    </select>
                    <div
                        *ngIf="formErrors.gender"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.gender }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item ">
                <div class="field__label-input-wrap">
                    <label
                        for="birthday"
                        class="label"
                    >
                        Date of Birth
                    </label>
                    <input
                        *ngIf="appSettings.IsCompatibilityMode === true"
                        required
                        class="input"
                        [class.input--invalid]="formErrors.birthday"
                        mask="00/00/0000"
                        id="birthday"
                        formControlName="birthday"
                        type="text"
                        placeholder="MM/DD/YYYY"
                    >
                    <input
                        *ngIf="appSettings.IsCompatibilityMode === false"
                        required
                        class="input"
                        [class.input--invalid]="formErrors.birthday"
                        id="birthday"
                        formControlName="birthday"
                        type="date"
                        placeholder="mm/dd/yyyy"
                    >
                    <div
                        *ngIf="formErrors.birthday"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.birthday }}
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <fieldset
        *ngIf="validDiscipline"
        class="form-section"
    >
        <legend>Contact Info</legend>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="country"
                    class="label"
                >
                    Country
                </label>
                <select
                    class="input input--select-menu input--large"
                    [class.input--invalid]="formErrors.countryId"
                    id="country"
                    formControlName="countryId"
                >
                    <option value>Select One</option>
                    <option
                        *ngFor="let c of countries"
                        [value]="c.id"
                    >
                        {{c.description}}
                    </option>
                </select>
                <div
                    *ngIf="formErrors.countryId"
                    class="error-message field__error-message"
                >
                    {{ formErrors.countryId }}
                </div>
            </div>
        </div>
        <div class="field  ">
            <div class="field__label-input-wrap">
                <label
                    for="address1"
                    class="label"
                >
                    Address 1
                </label>
                <input
                    class="input  input--large"
                    [class.input--invalid]="formErrors.address1"
                    id="address1"
                    formControlName="address1"
                    uppercase
                    maxlength="35"
                >
                <div
                    *ngIf="formErrors.address1"
                    class="error-message field__error-message"
                >
                    {{ formErrors.address1 }}
                </div>
            </div>
        </div>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="address2"
                    class="label"
                >
                    Address 2
                    <span class="label__help-text">(optional)</span>
                </label>
                <input
                    class="input  input--large"
                    [class.input--invalid]="formErrors.address2"
                    id="address2"
                    formControlName="address2"
                    uppercase
                    maxlength="35"
                >
                <div
                    *ngIf="formErrors.address2"
                    class="error-message field__error-message"
                >
                    {{ formErrors.address2 }}
                </div>
            </div>
        </div>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="postalCode"
                    class="label"
                >
                    Zip&#x2F;Postal Code
                </label>
                <input
                    class="input"
                    id="postalCode"
                    uppercase
                    [mask]="isUs ? '00000' : 'SSSSSSSSSS'"
                    [dropSpecialCharacters]="true"
                    (blur)="performZipCodeLookup()"
                    [class.input--invalid]="formErrors.postalCode"
                    formControlName="postalCode"
                >
                <div
                    *ngIf="formErrors.postalCode"
                    class="error-message field__error-message"
                >
                    {{ formErrors.postalCode }}
                </div>
                <div
                    *ngIf="badZipMessage"
                    class="error-message field__error-message"
                >
                    The zip code you entered cannot be found. Please verify you correctly entered the zip code. If you require further assistance contact NBRC.
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item ">
                <div class="field__label-input-wrap">
                    <label
                        for="city"
                        class="label"
                    >
                        City
                    </label>
                    <input
                        class="input"
                        id="city"
                        [class.input--invalid]="formErrors.city"
                        formControlName="city"
                        uppercase
                    >
                    <div
                        *ngIf="formErrors.city"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.city }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="state"
                        class="label"
                    >
                        State
                    </label>
                    <input
                        class="input"
                        id="state"
                        [class.input--invalid]="formErrors.state"
                        formControlName="state"
                        uppercase
                    >
                    <div
                        *ngIf="formErrors.state"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.state }}
                    </div>
                </div>
            </div>
        </div>
        <div class="field">
            <div class="field__label-input-wrap">
                <label
                    for="email"
                    class="label"
                >
                    Email
                </label>
                <input
                    class="input input--medium"
                    id="email"
                    [class.input--invalid]="formErrors.email"
                    formControlName="email"
                    type="email"
                >
                <div
                    *ngIf="formErrors.email"
                    class="error-message field__error-message"
                >
                    {{ formErrors.email }}
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="homePhone"
                        class="label"
                    >
                        Home Phone
                        <span class="label__help-text">(optional)</span>
                    </label>
                    <input
                        class="input"
                        id="homePhone"
                        formControlName="homePhone"
                        [class.input--invalid]="formErrors.homePhone"
                        type="tel"
                        [mask]="isUs ? '(000) 000-0000' : '0*'"
                        [dropSpecialCharacters]="true"
                    >
                    <div
                        *ngIf="formErrors.homePhone"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.homePhone }}
                    </div>
                </div>
            </div>
            <div class="field form-row__item">
                <div class="field__label-input-wrap">
                    <label
                        for="cellPhone"
                        class="label"
                    >
                        Cell Phone
                    </label>
                    <input
                        class="input"
                        id="cellPhone"
                        formControlName="cellPhone"
                        [class.input--invalid]="formErrors.cellPhone"
                        type="tel"
                        [mask]="isUs ? '(000) 000-0000' : '0*'"
                        [dropSpecialCharacters]="true"
                        [validation]="false"
                    />
                    <div
                        *ngIf="formErrors.cellPhone"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.cellPhone }}
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <fieldset *ngIf="validDiscipline">
        <legend>Password for your account</legend>
        <div class="field ">
            <label
                for="passwordNew"
                class="label"
            >
                Choose a password
            </label>
            <div class="password-container">
                <input
                    class="input"
                    formControlName="password"
                    id="password"
                    [class.input--invalid]="formErrors.password"
                    type="{{ showPassword ? 'text' : 'password' }}"
                    placeholder
                    autocomplete="off"
                >
                <img
                    src="/assets/images/eye.svg"
                    title="show password"
                    (click)="toggleShowPassword();"
                    height="10"
                    width="10"
                >
            </div>
            <div
                *ngIf="formErrors.password"
                class="error-message field__error-message"
            >
                {{ formErrors.password }}
            </div>
        </div>
        <div class="field ">
            <label
                for="passwordConfirmation"
                class="label"
            >
                Retype password
            </label>
            <div class="password-container">
                <input
                    class="input"
                    formControlName="passwordConfirmation"
                    id="passwordConfirmation"
                    validateEqual="password"
                    type="{{ showPasswordConfirmation ? 'text' : 'password' }}"
                >
                <img
                    src="/assets/images/eye.svg"
                    title="show password"
                    (click)="toggleShowPasswordConfirmation();"
                    height="10"
                    width="10"
                >
            </div>
            <div
                *ngIf="formErrors.passwordConfirmation"
                class="error-message field__error-message"
            >
                {{ formErrors.passwordConfirmation }}
            </div>
        </div>
    </fieldset>

    <div
        *ngIf="validDiscipline"
        class="form-actions"
    >
        <input
            class="button form-actions__item"
            type="submit"
            value="Create Profile"
        >
        <div
            *ngIf="formLevelErrors"
            class="error-message field__error-message"
        >
            <p *ngFor="let error of formLevelErrors">{{error}}</p>
        </div>
    </div>
</form>
